import {toRaw} from "vue";
import {db} from "@/modules/localDB/localDB";
import {useBookmark}  from "@/modules/reader/bookmark/bookmark";

/**
 * Save history to db every time when new drawing is added
 * parameter isRestoreFromSync tells whether it's restoring from sync server.
 * If yes, set isBookMarkChanged to false in local db so that the application will know that there are no local changes.
 * @param drawAttribute
 * @param targetPage
 * @param history
 * @returns {Promise<*>}
 */

const saveBookmark = async(isRestoreFromSync)=> {

    let bookmarks = toRaw(useBookmark().bookmarkState.bookmarkedPages);

    //bookmarked page is one based, and in String format for sync to the server side with backward compatibility...
    bookmarks = bookmarks.map(el=>{ return String(el+1); });

    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .modify({bookmark: bookmarks, isBookMarkChanged:!isRestoreFromSync});
}


export {
    saveBookmark
}